import { useTranslation } from 'react-i18next';

import { GridColDef } from '@mui/x-data-grid-pro';

export const useFixedColumns = () => {
  const { t } = useTranslation('common');
  return [
    {
      field: 'code',
      hideable: false,
      headerName: t('code'),
      flex: 1
    },
    {
      field: 'name',
      hideable: false,
      headerName: t('name'),
      flex: 1
    },
    {
      field: 'exportCode1',
      headerName: t('adminPortal.travelMovementsExport.exportCode1'),
      flex: 1
    },
    {
      field: 'exportCode2',
      headerName: t('adminPortal.travelMovementsExport.exportCode2'),
      flex: 1
    }
  ] as GridColDef[];
};
